import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';

import { getPatientSkillAcqCollectedData, deletePatientSkillAcqCollectedData } from './actions/targetsAction';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';

import { confirmAlert } from 'react-confirm-alert'; // Import
import Tooltip from '../../../../../../../../components/Tooltip';

class TodaysTADataModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
        }
    }

    componentWillMount = () => {
        this.props.getPatientSkillAcqCollectedData(this.state.patientId, this.props.uuid, this.props.creadteDate, "Task Analysis")
    }

    componentWillReceiveProps(nextProps) {
        // This is commented because of the two child modals
        // Please ask shubham first before uncommenting this

        // let self = this;
        // document.onkeydown = function (evt) {
        //     evt = evt || window.event;
        //     if (evt.keyCode === 27) {
        //         self.handleClose();
        //     }
        // };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal: true
        })

        confirmAlert({
            title: 'Delete Selected Trial',
            message: 'Are you sure you want to delete this trial?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.props.deletePatientSkillAcqCollectedData(this.state.patientId, this.props.uuid, this.props.creadteDate, Obj.id, Obj.skillsAcquisitionTargetId,"Task Analysis")
                        this.setState({
                            deleteModal: false
                        })
                    }

                },
                {
                    label: 'No',
                    onClick: () => {
                        this.setState({
                            deleteModal: false
                        })
                    }
                }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
        });
    }

    handleExpandRow = (Id) => {
        this.setState({ Id: Id });
        let display = this.refs['expandedClass' + Id].style.display;
        if (display === 'none') {
          this.refs['expandedClass' + Id].style.display = 'table-row';
          this.refs['expClass' + Id].className = 'classExpand fa fa-minus';
        } else {
          this.refs['expandedClass' + Id].style.display = 'none';
          this.refs['expClass' + Id].className = 'classExpand fa fa-ellipsis-h';
        }
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderInnerData(collectedDataId) {
        let TaskAnalysisInnerData =  (this.props.patientSkillAcqCollectedDataList && this.props.patientSkillAcqCollectedDataList.data.PatSkillsAcqTaskAnalysisCollectedData) || [];
        let filteredtaskAnalysisData = TaskAnalysisInnerData.filter((obj) => obj.collectedDataId === collectedDataId);
    
        if (!filteredtaskAnalysisData.length) {
          return <tr><td colSpan="7" className="text-center no-record">No record found.</td></tr>;
        }
        return filteredtaskAnalysisData.map((obj, index) => {
          return (
            <tr key={index}>
              <td></td>
              <td>{obj.taskName}</td>              
              <td>{obj.promptCodeName}</td>
              <td>{obj.abbreviation}</td>
            </tr>
          );
        });
      }

    renderData = (PatientSkillAcqCollectedDataList) => {
         const tableClass1 = classNames({
            'table': true,
            'middletable': true,            
          });
          const tableClass2 = classNames({
            'table': true,
            'childtable': true,
          });          
        PatientSkillAcqCollectedDataList = PatientSkillAcqCollectedDataList || [];
        if (!PatientSkillAcqCollectedDataList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientSkillAcqCollectedDataList.map((obj, index) => {
            return (
                <tr key={obj.id} className="trtableClass1">
                <td colSpan="5">
                  <table className={tableClass1}>
                    <tbody>
                      <tr className="trtableClass1Inner">
                        <td width="5%">
                          <div className="table_custom-check">
                            <button onClick={(e) => this.handleExpandRow(obj.id)} type="button" className="morebtn">
                              <i ref={'expClass' + obj.id} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                          </div>
                        </td>
                        <td width="55%">
                            {obj.programName && obj.programName.length > 0 ?
                            <Tooltip Description={obj.programName} />
                            : null}
                            {obj.targetName}
                        </td>                  
                        <td width="10%">
                            {obj.domainName && obj.domainName.length > 0 ?
                                <Tooltip Description={obj.domainName} />
                            : null}                       
                        </td>              
                        <td width="20%">{showFormatedDateandTime(obj.sessionDate)}</td>
                        <td width="10%"> 
                            <button onClick={(e) => this.handleDeleteClick(e, obj)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                        </td>
                      </tr>
                      <tr className="nohover" ref={'expandedClass' + obj.id} style={{ 'display': 'none' }}>
                        <td colSpan="4">
                          <table className={tableClass2}>
                            <thead>
                              <tr>
                                <th width="5%"></th>
                                <th width="35%">Step Name</th>                                
                                <th width="35%">Prompt Code</th>
                                <th width="25%">Abbreviation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.renderInnerData(obj.id)}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            )
        })
    }

    renderPatientSkillAcqCollectedDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
         
        const { patientSkillAcqCollectedDataList } = this.props;
        let PatientSkillAcqCollectedDataList = (patientSkillAcqCollectedDataList && patientSkillAcqCollectedDataList.data.PatientSkillsAcqCollectedData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="5%"></th>
                                            <th width="55%">Target Name</th>
                                            <th width="10%">Domain</th>
                                            <th width="20%">Session Date</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientSkillAcqCollectedDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientSkillAcqCollectedDataList()}
                </Dialog>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.patientSkillAcqActiveTarget.loading,
        patientSkillAcqCollectedDataList: state.patientSkillAcqActiveTarget.patientSkillAcqCollectedDataList,
    }
}

export default connect(mapStateToProps, { getPatientSkillAcqCollectedData, deletePatientSkillAcqCollectedData })(TodaysTADataModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/TodaysTADataModal.js